import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { GATEWAY_PAYMENT_TOKEN, PAYMENT_VALUE } from '../../../config/cacheKey';
import EmptyPageStyle from '../../../pages/emptyPageStyle/emptyPageStyle';
import PaymentReceiptSkeleton from '../../../pages/requestSteps/inquiryFee/resultPayment/paymentReceiptSkeleton';
import { GetArrearsPaymentResult } from '../../../services/payment.service';

export default function PaymentReceipt() {
    const [data, setData] = useState<any>();
    const [isData, SetIsData] = useState<boolean>(false);

    const getTokenFromLocal = localStorage.getItem(GATEWAY_PAYMENT_TOKEN)
    const queryClient = useQueryClient();

    const { mutate: GetArrearsPaymentResultMutation, isLoading } = useMutation(GetArrearsPaymentResult, {
        onSuccess: (data) => {
            if (data.isSuccess) {

                setData(data.data)
                SetIsData(false)

            }
            else {
                SetIsData(true)
            }
        }
    });
    useEffect(() => {
        const paymentResipt: any = queryClient.getQueryData(PAYMENT_VALUE)
        paymentResipt?.settledInstallment ? setData(paymentResipt) :
            GetArrearsPaymentResultMutation({ gatewayPaymentToken: getTokenFromLocal! });
    }, [])
    if (isLoading) {
        return <PaymentReceiptSkeleton />
    }
    if (isData) {
        return <EmptyPageStyle prefixText="رسید پرداختی" highlightedText=" یافت" suffixText="نشد" />
    }
    return (
        <div
            style={{
                background: 'none',
                border: 'none !important',
                position: 'relative',
                width: '100%',
                maxWidth: '600px',
                margin: 'auto',
                backgroundImage: `url(/images/PaymentReceipt.png)`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: '100% 100%',
                backgroundPosition: 'top center',
                height: '370px',
                display: 'flex',
                alignItems: 'flex-start',
                justifyContent: 'center',
                overflow: 'hidden',
                color: '#212121'

            }}
        >
            <Grid container spacing={2} className='' justifyContent="center ">
                <Grid item xs={12} textAlign="center" className="yekanBakhFaNum  !mt-14">
                    <div style={{ fontSize: '1.2rem' }}  >{(data?.amount + (data?.penaltyAmount ? data.penaltyAmount : 0)).toLocaleString('fa')} ریال</div>
                    {data?.paymentStatus === 'Verified' ? <div className="bgSecondaryColorLight badge mt-4 mb-6">
                        <CheckCircleIcon />
                        &nbsp;پرداخت موفق
                    </div> : <div className=" badge mt-4 mb-6" style={{ background: '#FF617C' }}>
                        <CancelIcon />
                        &nbsp;پرداخت ناموفق
                    </div>}

                </Grid>

                <Grid item xs={12}>
                    <hr className="indented-hr" />
                </Grid>

                <Grid container item xs={12} className="yekanBakhFaNum  !mx-6" textAlign="center">

                    <Grid container xs={12} className="mt-2" >
                        {data?.trackingNumber && <><Grid item xs={6} textAlign="right" className="!mt-4 ">شماره پیگیری:</Grid><Grid item xs={6} textAlign="left" className="!mt-4">{data?.trackingNumber}</Grid></>}
                        {data?.paymentDatePersian && <><Grid item xs={6} textAlign="right" className="!mt-4 ">تاریخ و زمان پرداخت:</Grid><Grid item xs={6} textAlign="left" className="!mt-4">{data?.paymentDatePersian}</Grid></>}
                        <Grid item xs={6} textAlign="right" className="!mt-4 ">  درگاه پرداخت:</Grid>
                        <Grid item xs={6} textAlign="left" className="!mt-4 ">{data?.gateway} </Grid>
                    </Grid>

                </Grid>
            </Grid>
        </div>
    )
}
